import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const EmailExistsError = () => {
    const { t } = useTranslation();

    return (
        <Alert data-testid="email-exists-error" severity="error">
            {t('formErrors.emailExistsError.alreadyAssigned')}
        </Alert>
    );
};
